'use strict';

module.exports = {
  template: require('./performance-review-agreement-lock.html'),
  controller: require('./performance-review-agreement-lock.controller'),
  controllerAs: 'vm',

  bindings: {
    isLocked: '<',
    onLock: '&',
    token: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-agreement-lock/index.js
 ** module id = 259
 ** module chunks = 0
 **/